import { gql } from 'graphql-request'

interface IPerk {
  perk: string
  order: number
  applicableTo: { id: string; planLevel: number }[]
}

export type Perk = {
  title: string
  tiers: number[]
}

export const createPerksQuery = () => gql`
  query getPerks {
    Perks(limit: 100, sort: "order") {
      docs {
        perk
        order
        applicableTo {
          id
          planLevel
        }
      }
    }
  }
`

export const mapPerks = (doc: unknown): Perk[] | undefined => {
  const data = doc as { Perks?: { docs?: IPerk[] } }
  const perks = data?.Perks?.docs

  if (!perks?.length) return undefined

  return perks.map((perk) => ({
    title: perk.perk,
    tiers: perk.applicableTo?.map((tier) => tier.planLevel) ?? [],
  }))
}
